import { useLocation } from "react-router-dom";
import { useEffect } from "react";

let customPath : CustomPathInterface = { previousPath: '', currentPath: ''};

interface CustomPathInterface {
    previousPath: string;
    currentPath: string;
}

const usePathState = () : CustomPathInterface => {
    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        customPath = { previousPath: customPath.currentPath, currentPath: path };
    }, [path]);

    return customPath;
};

export default usePathState;